import TemplateNames from './TemplateNames';

export default {
  title: 'E-mailuri automate',
  labels: {
    empty_list: 'Niciun șablon găsit',
    load_failed: 'Nu s-au putut încărca e-mailurile tale automate. Reîncarcă pagina sau contactează asistența.',
    on: 'Activat',
    off: 'Dezactivat',
  },
  fields: {
    name: 'Nume',
    messages_delivered: 'Mesaje livrate',
    open_rate: 'Rată deschidere',
    click_rate: 'Rată accesare',
    status: 'Stare',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Eroare la actualizarea stării',
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
